export const enResource = {
  buttonsText: {
    Continue: 'Continue',
    Submit: 'Submit',
    Cancel: 'Cancel',
    Close: 'Close',
    Save: 'Save',
    SaveChanges: 'Save changes',
    Approve: 'Approve',
    Reject: 'Reject',
    Delete: 'Delete',
    deleteQuestion: 'Delete question',
    duplicate: 'Duplicate',
    Invite: 'Invite',
    AddAnother: 'Add Another',
    AddPeople: 'Add People',
    AddQuestion: 'Add Question',
    AddNew: 'Add new',
    AddNewSource: 'Add new source',
    CreateNew: 'Create new',
    Remove: 'Remove',
    UploadPhoto: 'Upload an image',
    RemovePhoto: 'Remove photo',
    SaveProfile: 'Save profile',
    RequestChange: 'Request change',
    TopUp: 'Top up',
    ConnectWithStripe: 'Connect with Stripe',
    Skip: 'Skip',
    SeeDetails: 'See details',
    Update: 'Update',
    ChoseFile: 'Choose file',
    SkipForNow: 'Skip for now',
    ConnectNow: 'Connect now',
    ConnectPlaid: 'Connect Plaid',
    SaveLaunch: 'Save & Launch',
    Unlink: 'Unlink',
    DownloadSelection: 'Download selection',
    Yes: 'Yes',
    No: 'No',
    UploadAnotherReceipt: 'Upload another receipt',
    CancelApproval: 'Cancel Approval',
    EditRequest: 'Edit Request',
    SendReceiptReminder: 'Send receipt reminder',
    UploadReceipt: 'Upload Receipt',
    Enable: 'Enable',
    comingSoon: 'Coming soon',
    shareIdea: 'Share Idea',
    addCard: 'Add card',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    addNewCard: 'Add new card',
    previewRequest: 'Preview Request',
    publish: 'Publish',
    confirmAction: {
      topup: 'Confirm top up',
      unload: 'Confirm unload',
      'change-topup-amount': 'Change top up amount',
      submit: 'Submit',
    },
  },
  actionModalTitles: {
    Topup: 'Top up',
    Unload: 'Unload',
    Change: 'Change top up amount',
  },
  people: {
    title: 'People',
    searchPlaceholder: 'Search people',
    addPersonTitle: 'Add new person',
    changeRole: 'Change Role',
  },
  metrics: {
    hints: {
      balanceRequired: 'Balance required to fund approved future transactions across all cards',
      totalSpend: 'Total spend across all cards and card programmes since account creation',
      limit: 'Limit hint',
      connectedAccount: 'connectedAccount hint',
    },
  },
  directory: {
    title: 'Directory',
  },
  deleteConfirmation: {
    title: 'Confirmation',
    description: 'Are you sure you want to delete this? It will be gone forever.',
    confirmDelete: 'Confirm Delete',
    deleteOneTimeSpendRequest: 'Are you sure you want to delete this one time spend request. It will be gone forever',
  },
  cancelConfirmation: {
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc enim euismod vivamus non consectetur. ',
    confirmDelete: 'Confirm Cancel',
    cancelOneTimeSpendRequest: 'Are you sure you want to cancel this one time spend request?',
  },
  requestApp: {
    title: 'Flow Request',
    description:
      'If you’ve an idea for an flow that would help you better manage your organisation spend we’d love to hear it.',
  },
  inputPlaceholders: {
    search: 'Search',
  },
  uiMessages: {
    success: 'Success.',
    warning: 'Warning.',
    failed: 'Failed.',
    confirmSuccess: 'Email Successfully confirmed you can login now.',
    pleaseConnectPlaid: 'Please connect this card with Plaid.',
    ChangesSaved: 'Changes saved.',
    successMessage: 'Aute velit enim eu mollit ex irure irure nulla reprehenderit amet magna.',
    error: 'Error.',
    errorMessage: 'An unexpected error occurred.',
    loginFail: 'Oops - Your email or password is incorrect.',
    imageFail: 'Please upload a PDF, image or zip file.',
    receiptUploaded: 'Receipt uploaded.',
    receiptDeleted: 'Receipt deleted.',
    great: 'Great!',
    cardAdded: 'Card was successfully added!',
    cardUpdated: 'Card was successfully updated!',
    copiedToClipboard: 'copied to clipboard.',
    emailChange:
      'We’ve sent a confirmation link to your new email address. Please check your emails to confirm your new email address',
    updateProfile: 'Profile data has been updated.',
    emailChangeHelp: 'Please contact our support if you wish to change the email.',
    receiptReminderSuccess: 'Receipt reminder successfully sent',
    receiptReminderError: 'You already sent a reminder today',
    requestDeleteSuccess: 'Request successfully deleted.',
    requestDenySuccess: 'Request successfully denied.',
    codeSubmitErrorValue: 'This code does not match, check your email for the latest code and try again',
    countryUnsupported:
      'We’re only supporting United States at the moment. We’ll notify you when your country is supported',
    codeSubmitErrorLimit: 'You have reached the maximum number of attempts, click resend code ',
    automationPublished: 'Automation published.',
  },
  error: {
    user: {
      forgotPassword: {
        notfound:
          'Oops, we couldn’t find your reset password token. Please click forgot password again to generate a new one',
        expired: 'Oops, your reset password token is expired. Please click forgot password again to generate a new one',
      },
    },
  },
  customer: {
    password: {
      currentPassword: {
        match: 'Your current password does not match. Your password has not been changed',
      },
    },
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    location: 'Location',
  },
  invitation: {
    title: 'Join',
    title2: 'Solvers team',
  },
  signInForm: {
    signIn: 'Sign in',
    signInToYourAccount: 'Sign in to your account',
    forgotPassword: 'Forgot password',
    requestPasswordReset: 'Request password reset',
  },
  signUpForm: {
    signUp: 'Sign Up',
    currencyError: 'We’re only supporting EUR at the moment. We’ll notify you when your currency is supported',
    passwordCheckSuccess: 'This password is safe to use and appeared in no known data breaches.',
    passwordCheckWarning: {
      part1: "This password isn't safe to use and appeared in.",
      part2: " data breaches. You can still use it, but you probably shouldn't.",
    },
  },
  forgotPasswordForm: {
    notification: {
      successTitle: 'Almost done!',
      followInstructions: 'Please follow the instructions sent to',
      toReset: 'to reset your password',
    },
    forgotYourPassword: 'Forgot your password?',
    enterYourEmail: 'Enter your email below',
  },
  resetPasswordForm: {
    notification: {
      success: 'Your password has been changed',
    },
    resetPassword: 'Reset your password',
    enterPassword: 'Enter your password below',
  },
  addBillingCardForm: {
    title: 'Add Billing Card',
    description: "You're almost there. Add your billing card to activate your 14 day free trial",
    description2:
      "Note: This card will be charged after your 14 day trial period. We'll remind you at the end of the 14 day trial before you're charged. You can change this card at any point in the billing section in settings.",
  },
  tutorialModal: {
    step1: {
      title: 'Setting Up',
      description:
        "We've built WhenThen to work in your existing team communication channels such as Slack. All you have to do is enable your first WhenThen app, like One-Time Spend, allow the app to run in your Slack workspace and now your team can make One-Time Spend requests and you can approve from within Slack.",
    },
    step2: {
      title: 'Customize',
      description:
        'Really what makes WhenThen app stand out from the crowd is the ability to customize an app to your liking. You can ask spenders for specific information, before approval, allow different users to spend without approval, request spenders to perform actions after an approval (such as upload a receipt) and easily integrate your app so that it communicates with our apps you use, such as uploaded receipts being added to Xero.',
    },
    step3: {
      title: 'Review Payments',
      description:
        'When transactions need approval or have been approved you can check your app profile page such as this to see the status of a transaction, approve or decline requests, pause previously approved requests and remind the spender to do something post purchase.',
    },
  },
  transaction: {
    titleFuture: 'Future transactions',
    titlePast: 'Past transactions',
    moreApps: 'Coming soon',
    subscriptions: {
      description:
        'Create a spend approval flow for subscriptions and issue a bank card or secure virtual cards upon approval.',
    },
    'recurring-spend-request': {
      description:
        'Create a payment flow to top up a virtual card which is on file with a merchant upon spend approval.',
    },
    'gifts-and-rewards': {
      description: 'Create specific amount virtual gift or reward cards to be used with specific merchants.',
    },
    'te-spend': {
      description:
        'Create physical and virtual travel and expense cards for your people with controlled spend and top-ups.',
    },
    reimbursements: {
      description: 'Create a payment flow to automatically  reimburse out of pocket spend.',
    },
    'spend-request': {
      description:
        'Create a payment flow for one-time spend approval and issue your bank card or secure virtual cards upon approval.',
    },
    searchPeople: 'Search people',
  },
  app: {
    title: 'Flows',
    moreApps: 'Coming soon',
    subscriptions: {
      description:
        'Create a spend approval flow for subscriptions and issue a bank card or secure virtual cards upon approval.',
    },
    'recurring-spend-request': {
      description:
        'Create a payment flow to top up a virtual card which is on file with a merchant upon spend approval.',
    },
    'gifts-and-rewards': {
      description: 'Create specific amount virtual gift or reward cards to be used with specific merchants.',
    },
    'te-spend': {
      description:
        'Create physical and virtual travel and expense cards for your people with controlled spend and top-ups.',
    },
    reimbursements: {
      description: 'Create a payment flow to automatically  reimburse out of pocket spend.',
    },
    'spend-request': {
      description:
        'Create a payment flow for one-time spend approval and issue your bank card or secure virtual cards upon approval.',
    },
    'request-app': {
      description: "Have an idea for an flow? we'd love to hear it!",
    },
  },
  dashboard: {
    dashboardTitle: 'Dashboard',
    createNewButtonText: 'Create new',
    spendingOverviewSubtitle: 'Spending overview',
    getStartedBlockTitle: 'Get started',
    getStartedTitle: 'Set up One-Time Spend flow',
    getStartedDescription: 'When someone want to make a one-time purchase then issue a one-time use virtual card.',
    getStartedButtonText: 'Enable Flow',
    purchaseRequestText: {
      title: 'One-Time Spend Request',
      pendingApproval: 'Pending approval',
      pendingTransaction: 'Pending transactions',
      total: 'Total',
    },
    pending: 'Pending approval',
    approved: 'Pending transactions',
    requiresAction: 'Requires attention',
  },
  tables: {
    requests: {
      isRequestingToPurchase: 'is requesting to purchase',
    },
  },
  miniProfileMenu: {
    editProfile: 'Edit profile',
    logOut: 'Log out',
  },
  editProfile: {
    securityForm: {
      success: 'Your password has been changed.',
      passwordMatch: "You can't use the same password.",
    },
    photoForm: {
      success: 'Your profile photo has been updated.',
      successRemoving: 'Your profile photo has been removed',
      cropImage: 'Crop your image!',
      confirmRemovingDescription: 'Remove profile photo?',
    },
  },
  common: {
    continueText: 'Continue',
    underTitle: '',
    haveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
  },
  emailConfirm: {
    confirmedMessage: 'Sweet! you are human. Click continue to enter the platform.',
    confirmed: 'Email was confirmed',
    pleaseConfirm: 'Please confirm your email address',
    checkMessage: "We've sent you an email to the email address you just provide. Please check and confirm.",
    linkText: 'Resend email',
  },
  spendRequest: {
    title: 'Activate One-Time Spend flow',
    questionsBlockTitle: 'Than request answers to these questions',
    addQuestion: '+ Add question',
    title2: 'Setup purchase order app',
    optionalText: 'Optional',
    bottomTitle: 'This flow can be accessed in',
    option1: 'Slack',
    option2: 'Whenthen web app',
    helperText: 'This flow is always accessible in this web app.',
    addToSlack: {
      title: 'Add WhenThen to Slack',
      description:
        'WhenThen needs permission to be added to your Slack workspace so you and your team can interact with it.',
      skipText: 'Skip',
    },
    settings: {
      sideMenuTitle: 'Question settings',
      questionType: 'Question type',
      requiredField: 'Mandatory question',
      currency: 'Currency',
      chooseQuestionType: 'Choose a question type',
      fieldTypeText: {
        merchantSelect: 'Merchant select',
        select: 'Drop down',
        checkboxes: 'Multi-Choices',
        shortText: 'Short text',
        url: 'URL',
        longText: 'Long Text',
        numberInput: 'Number Input',
      },
    },
    invitePeople: {
      title: 'Invite people',
      title2: 'Bring your team to WhenThen.',
      description: 'Urna non, gravida urna nec amet eu consequat suspendisse. Suspendisse vel morbi egestas.',
      buttonText: 'Invite',
      skipText: 'Skip',
    },
    customizeSpendRequest: {
      title: 'Customise One-Time Spend flow',
      questions: {
        title: 'Example request',
        description:
          'These are popular pre-set questions that all are partners use to get the info they need from a spender to approve or decline a purchase.',
        linkText: 'Learn more',
      },
      approvals: {
        title: 'Invite people',
        description:
          'Here you can add people in your team or org that can approve or decline a one-time spend request.',
        linkText: 'Learn more',
        labelKey: 'Who should approve or decline it?',
      },
      funding: {
        title: 'Funding',
        description:
          "When a spenders purchase is approved they'll be issued a one-time/single use digital bank card via Slack.",
        linkText: 'Learn more',
      },
      afterPurchase: {
        title: 'After purchase',
        description:
          'When the spender completes the purchase your funding card will be charged for the purchase amount. Learn more',
        linkText: 'Learn more',
      },
      continueText: 'Continue',
    },
    addFundingSource: {
      title: 'Select payment method',
      description:
        "Your funding source is how we create the one-time/single use cards. When you approve a purchase, WhenThen creates a one-time/single use card from the bank card you provide below. When the purchase is complete this bank card will be charged for the amount of the purchase. On your card statement you'll see a transaction like this.",
      bottomText:
        'Note. this card will also be charged post your 14 day trial period for your WhenThen subscription. You can change this card at any point in the billing section in settings.',
      buttonText: 'Finish setup',
    },
    stripeConnect: {
      title: 'Connect Funding Source',
      title2: 'Connect with Stripe to  issue virtual cards',
      description:
        'WhenThen needs permission to connect to your Stripe account so you can fund and issue virtual cards to your team.',
      successTitle: 'Congrats',
      successDescription: 'Sweet! you are human.  Click continue to enter the platform.',
    },
  },
  programmeConfig: {
    step1: {
      title: 'Configure the card programme',
      description: 'Get started by giving your card programme a look and feel and set it`s core controls.',
    },
  },
  stripeConfigForm: {
    title: 'Enter Stripe API Keys',
    description: 'Stripe account so you can fund and issue virtual cards to your team.',
    descriptionLink: 'Get the keys from here',
  },
  setupPurchaseModal: {
    title: 'Congrats!',
    description:
      "You're all set for smart, controlled spending. Give it a try now, we've just sent you a message in Slack.",
    buttonText: 'Continue',
  },
  takeAction: {
    title: 'Take action',
    description: 'There are no open actions. Enjoy your day.',
  },
  recentTransaction: {
    title: 'Recent transactions',
    description: 'You have no transactions yet.',
    description2: 'Create your first virtual card from a card programme and use it to make a purchase.',
    linkText: 'Create a card programme',
    emptyFuture: 'Future transactions from multi-use cards being used for recurring payments will be presented here.',
    emptyPrevious: 'There are no previous transactions',
  },
  'spend-request': {
    inputForm: {
      label: 'New card',
      title: 'Customise these questions and create your own',
      description: 'A request has been made by @John for €1000.00 to buy A Laptop from Apple. Reason: My dog ate it',
      help: 'A request has been made by John for €1000.00 to buy A Laptop from Apple. Reason: My dog ate it',
    },
    approvers: {
      label: 'Who should approve or decline it?',
      description: '',
      help: 'Here you can add people in your team or org that can approve or decline a one-time spend request.',
    },
    'after-transaction': {
      label: 'What happens after approval?',
      description: '',
      help: "When a spenders purchase is approved they'll be issued a one-time/single use digital bank card via Slack.",
      requestReceipt: {
        label: 'What happens after purchase is made?',
        description: '',
        help: 'When the spender completes the purchase your funding card will be charged for the purchase amount.',
      },
    },
    oneTimeSpend: {
      title: 'One-Time Spend',
      tabTitles: {
        1: 'Transactions',
        2: 'Actions',
        3: 'Configure',
        4: 'Connections',
      },
      future: 'Future',
      today: 'Today',
      thisWeek: 'This week · ',
      buttonText: 'Create new',
      noActions: 'There are no open actions.',
      enjoyDay: 'Enjoy your day.',
    },
  },
  infoRequest: {
    requestText: 'Requested by',
    requestType: 'Type',
    requestAmount: 'Request Amount',
    accountCategory: 'Account Category (from Xero)',
    whatFor: 'What for',
    reason: 'Reason',
    dateText: 'Date Requested',
    dateText2: 'Date Approved',
    approvedText: 'Approved by',
    approvedDateText: 'Date Approved',
    cardText: 'Card',
    receiptText: 'Receipt',
    cardDescription: 'The card to use for this transaction will be posted here when this request is approved.',
    receiptDescription: 'After transaction a receipt will be uploaded.',
    merchant: 'Merchant',
    merchantDetails: 'Merchant details',
    merchantUrl: 'Merchant Url',
    billinDetails: 'Billing Details',
    companyName: 'Company name',
    vat: 'VAT',
    billingAddress: 'Billing address',
    merchantCategory: 'Merchant Category',
    description: 'Description',
  },
  funding: {
    title: 'Funding source',
    setUp: 'Add a funding source',
    connectTitle: 'Connect funding source',
    connectDescription:
      'Pellentesque cras ipsum, tortor, gravida. Scelerisque eget metus ullamcorper maecenas pellentesque donec suspendisse id ipsum.',
    bottomText:
      'In order to confirm the card we are going to reserve €150 on the card which is going to be release in 3 days.',
    addCardTitle: 'Add card',
    addCardDescription:
      'Pellentesque cras ipsum, tortor, gravida. Scelerisque eget metus ullamcorper maecenas pellentesque donec suspendisse id ipsum.',
    empty: 'Add card or account details to issue to requestors, or fund virtual cards, upon spend approval',
    editCardTitle: 'Update card',
    editCardDescription:
      'Any update you make will here will effect all requestor who have this card but are yet to make a transaction.',
    editBillingCardDescription: 'Enter the new platform billing cards below.',
  },
  connectBank: {
    title: 'Connect your bank',
    description: 'In order to issue this card for approved spend we need you to connect with your bank.',
    cardTitle: 'Auto-sync transactions to whenthen',
    cardDescription: 'whenthen will find transactions in your bank account that match the spend approvals.',
    steps: {
      title: 'How it works?',
      1: {
        title: 'Purchase is made on your card',
        description: 'The requestor use the issue bank card number to make a purchase.',
      },
      2: {
        title: 'Bank transactions are synced with whenthen',
        description: 'whenthen finds the transaction in your bank and presents it to the requestor for confirmation',
      },
      3: {
        title: 'Confirm and reconcile the transaction',
        description: 'When the requestor confirms it is their transaction, whenthen will ask them to provide a receipt',
      },
    },
  },
  connectVirtualCard: {
    title: 'Fund Virtual Card',
    description: ' Please select the payment method below for how you’d like to fund your virtual cards.',
  },
  settings: {
    title: 'Settings',
    options: {
      generalSettings: 'General settings',
      billing: 'Billing',
    },
    currency: {
      title: 'Currency',
      selectLabel: 'Primary currency',
    },
    billing: {
      billinDetails: {
        title: 'Billing details',
        title2: 'Billing address',
        email: 'Billing email',
        name: 'Company Name',
        fullName: 'Full name',
        address: 'Address',
        empty: 'Billings card empty',
        company: 'Company',
        street: 'Street',
        city: 'City',
        country: 'Country',
        description: 'Description',
      },
      paymentDetails: {
        title: 'Payment details',
        currentPlan: 'Current plan',
      },
    },
    invoices: {
      title: 'Invoices',
      titlePast: 'Past invoices',
    },
  },
  topUp: {
    title: 'Stripe Issuing Balance',
    lowBalance: 'Low balance, please top up.',
    form: {
      title: 'Top up',
      check1: 'Confirm send',
      check2: 'to WhenThen.',
    },
  },
  stripe: {
    key: {
      invalid: 'Invalid Stripe key',
    },
  },
  uploadCard: {
    title: 'Upload receipt',
    description: 'A receipt will be here after the transaction.',
    dropFileHere: 'Drop the files here ...',
    dropFile: "Drag 'n' drop some files here",
  },
  configureSlack: {
    title: 'Connect Slack',
    description: 'Add whenthen to your Slack workspace and make spend requests and approvals from within Slack.',
    listItems: {
      1: 'Controlled user access to the whenthen Slack bot',
      2: 'Make spend requests and approvals within any channel',
      3: 'Receive Slack reminders to submit receipts for approved spend',
    },
  },
  slackMessages: {
    success: 'Slackbot was added.',
    text1: 'Slackbot was added to your workspace. We are importing your users.',
    text2: 'Slackbot was added to your workspace. You can now search for people.',
    text3: 'Slackbot was added to your workspace. You can now use then Slack with this App.',
  },
  itemAttention: {
    title: 'Requires attention',
    chooseMathing: 'Choose a matching transactions',
  },
  transactionQuestion: {
    text1: 'Have you made this transaction yet?',
    text2: 'Do you intend to make this transaction?',
    text3: 'OK, we’ll keep a look out for the transaction',
    deleteText: 'No, delete it',
  },
  connections: {
    live: 'Live',
    archive: 'Archive',
    directory: 'Directory',
    noDirectoryConnections: 'There are no available connections at the moment',
    retry: 'Refresh',
    fetchingError: 'There was an error while fetching data',
    slack: {
      title: 'Slack',
      subtitle:
        "Slack is where work flows. It's where the people you need, the information you share, and the tools you use come together to get things done.",
    },
    plaid: {
      title: 'Plaid',
      subtitle:
        'Plaid helps all companies build fintech solutions by making it easy, safe and reliable for people to connect their financial data to apps and services.',
      connect: 'Connect with Plaid',
      plaidError: 'Please connect Plaid to continue',
    },
    stripe: {
      title: 'Stripe',
      subtitle: 'Urna non, gravida urna nec amet eu consequat suspendisse. Suspendisse vel morbi egestas.',
    },
  },
  confirmDetails: {
    title: 'Company details',
    description:
      'You’ve successful signed in via Slack. Please confirm the details below to continue your registration.',
  },
  checklist: {
    title: 'Get started',
    itemList: [
      {
        title: 'Enable first flow',
        buttonText: 'Enable',
      },
      {
        title: 'Connect with your businesses bank',
        buttonText: 'Connect',
      },
      {
        title: 'Invite colleagues',
        buttonText: 'Invite',
      },
      {
        title: 'Enable whenthen in Slack',
        buttonText: 'Enable Slack',
      },
      {
        title: 'Launch flow',
        buttonText: 'Go to flows',
      },
      {
        title: 'Make a spend request',
        buttonText: 'New spend request',
      },
      {
        title: 'Approve a spend request',
        buttonText: 'Go to dashboard',
      },
      {
        title: 'Export reconciled transactions',
        buttonText: 'Go to transactions',
      },
      {
        title: 'Check company billing details',
        buttonText: 'Billing details',
      },
      {
        title: 'Complete the checklist to claim a prize  🎁',
        buttonText: 'Complete the checklist to calm',
      },
    ],
  },
  cards: {
    SINGLE: 'Single-use',
    MULTI: 'Multi-use',
    MUTLI: 'Multi-use',
    topup: {
      request: 'Request top up',
      auto: 'Auto top up',
    },
  },
  programme: {
    SINGLE: 'Single-use',
    MULTI: 'Multi-use',
    'auto-topup': 'Auto top up',
    'allow-topup-request': 'Request top up',
  },
  payments: {
    view: {
      deleteMessage: 'Are you sure you want to delete',
    },
    refund: 'Refund',
    refundText: {
      sure: 'Are you sure you want to refund ',
      to: ' to ',
    },
    refundSuccessful: 'Refund successful.',
    cancel: 'Cancel',
    cancelText: {
      sure: 'Are you sure you want to cancel ',
      to: ' to ',
    },
    cancelSuccessful: 'Cancel successful',
    issues: {
      modal: {
        title: 'Create new issue',
      },
    },
  },
  yup: {
    positive: () => 'must be a positive number',
    less: (value) => `must be less than ${value}`,
    more: (value) => `must be greater than ${value}`,
  },
  flowEditor: {
    left: {
      nodeNotFound: 'No nodes found with the name "{{search}}"',
    },
    right: {
      nodeSettings: 'Node Settings',
    },
    condition: {
      logical: {
        title: {
          right: 'of the following conditions are met:',
        },
      },
    },
  },
  errors: {
    errorFetchingData: 'Error fetching data.',
    errorSavingData: 'Error saving data.',
  },
  flowHeaderLinks: {
    automation: 'Automation',
    test: 'Test',
  },
};
